import { AlertTriangle, CheckCircle2, X } from 'lucide-react';

export type CatalogFloatingAlertTone = 'error' | 'success';

interface CatalogFloatingAlertProps {
  tone: CatalogFloatingAlertTone;
  title: string;
  body: string;
  onClose: () => void;
}

export function CatalogFloatingAlert({
  tone,
  title,
  body,
  onClose,
}: CatalogFloatingAlertProps): JSX.Element {
  const Icon = tone === 'success' ? CheckCircle2 : AlertTriangle;
  const tone_class =
    tone === 'success'
      ? 'border-success/40 bg-success/15 text-success'
      : 'border-destructive/40 bg-destructive/10 text-destructive';

  return (
    <div
      role="alert"
      className={`fixed right-4 top-4 z-[60] flex w-[min(24rem,calc(100vw-2rem))] items-start gap-3 rounded-md border p-3 text-sm shadow-lg ${tone_class}`}
    >
      <Icon className="mt-0.5 h-4 w-4 shrink-0" aria-hidden />
      <div className="min-w-0 flex-1">
        <p className="font-semibold">{title}</p>
        <p className="mt-0.5 opacity-90">{body}</p>
      </div>
      <button
        type="button"
        onClick={onClose}
        className="rounded-sm p-1 opacity-70 hover:opacity-100"
      >
        <X className="h-4 w-4" aria-hidden />
      </button>
    </div>
  );
}
